import { render, staticRenderFns } from "./Exclusivity.vue?vue&type=template&id=72b8adc6&scoped=true&"
import script from "./Exclusivity.vue?vue&type=script&lang=js&"
export * from "./Exclusivity.vue?vue&type=script&lang=js&"
import style0 from "./Exclusivity.vue?vue&type=style&index=0&id=72b8adc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b8adc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
